import { Component, OnInit, Inject, Input, Output, Injectable } from '@angular/core';
import { ModalBase, ModalDialogService } from '@nx-fe/shared-dialogs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CredentialValidators } from 'xsmodules/settings/components/integration-settings/mc-integration-settings/credentials.validator';
import { DomainValidators } from 'xsmodules/settings/components/integration-settings/mc-integration-settings/domain.validator';
import { XsI18nPipe } from '@nx-fe/pipes';

export interface FileSaveParams {
  fileName: string;
  extension?: string;
}
export interface PromptDialogData {
  title: string;
  icon: string;
  confirmButton: string;
  inputTitle: string;
  extension: string;
  placeHolder: string;
  regexFilter: RegExp;
  unallowedChar: string;
  fileParams: FileSaveParams;
}

@Component({
  selector: 'xs-prompt-dialog',
  templateUrl: './prompt-dialog.component.html',
  styleUrls: ['./prompt-dialog.component.scss'],
})
export class PromptDialogComponent implements OnInit {
  fileSaveParams: FileSaveParams;
  dialogParams: PromptDialogData;
  form: FormGroup;
  constructor(
    private fb: FormBuilder,
    private xsi18nPipe: XsI18nPipe,
    public dialogRef: MatDialogRef<PromptDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PromptDialogData
  ) {}

  input: any;

  ngOnInit(): void {
    this.buildForm();
    this.dialogParams = this.data;
    this.fileSaveParams = this.data.fileParams;
    this.fileName.setValue(this.dialogParams.placeHolder);
  }

  /** Cancels the modal dialog */
  onCancel(): void {
    this.dialogRef.close();
  }

  isValid = (): boolean => {
    const valid = this.form.get('fileName').valid;
    return valid;
  };

  private buildForm = () => {
    this.form = this.fb.group({
      fileName: ['', Validators.required],
    });
  };

  /** Closes dialog and returns file and extension */
  confirm(): void {
    if(!!this.fileSaveParams) {
      this.fileSaveParams.fileName = this.form.get('fileName').value; // Side Effect
      this.dialogRef.close(this.fileSaveParams);
    } else {
      this.dialogRef.close(true);
    }
  }

  getErrorMessage(): string {
    return this.xsi18nPipe.transform('prompt_dialog_Error_InvalidInput');
  }

  get fileName(): AbstractControl {
    return this.form.get('fileName');
  }
}
